import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiCaptchaImage } from 'idt-ecommerce-api/_api/api-secure/api-secure.models';
import { ApiSecureService } from 'idt-ecommerce-api/_api/api-secure/api-secure.service';

import { CaptchaImage } from './secure.models';


@Injectable()
export class SecureService {

  constructor(
    private readonly apiSecureService: ApiSecureService
  ) {}

  /**
   * Obtiene la imagen captcha y el id
   */
  public getCaptchaImage(storeId: string, langId: string): Observable<CaptchaImage> {
    return this.apiSecureService
      .getCaptchaImage(storeId, langId)
      .pipe(
        map((apiCaptchaImage: ApiCaptchaImage) => {
          return apiCaptchaImage as CaptchaImage;
        })
      );
  }

}
